import axios from 'axios';
import React, { Component } from 'react';
import * as Constants from "../../Constants/index";
import swal from "sweetalert";

class LoginOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: '',
    };
  }

  handleChange = (event) => {
    const value = event.target.value;
    if (/^\d{0,10}$/.test(value)) {
      this.setState({ otp: value });
    }
  };

  handleSubmit =  async (event) => {
    event.preventDefault();
      // console.log('OTP Submitted:', this.state.otp);
      if(!this.state.otp){
        swal("Please enter your number")
      }
      else{
        const res =  await axios.post(Constants.api + `auth/login-otp`, {
           mobile: this.state.otp
         }, {
                   headers: {
                     appVersion: Constants.av,
                     platform: Constants.pt,
                     "Accept-Language": localStorage.getItem("language"),
                     company: 1,
                     program: 1,
                   }
                 })
                 .then((response)=>{
                   console.log(response)
                   if(response.data.code === 16001){
                     localStorage.setItem("mobileNumber", this.state.otp)
                     window.location = '/verify-otp';
                   }
                   else{
                     swal(response.data.msg);
                   }
                 })
                 // console.log("res...",res)
      }
  };

  render() {
    return (
      <div>
        <main className="main-content mt-0">
          <div className="page-header align-items-start min-vh-100">
            <span className="mask bg-gradient-dark opacity-6"></span>
            <div className="container my-auto">
              <div className="row">
                <div className="col-lg-4 col-md-8 col-12 mx-auto">
                  <div className="card z-index-0 fadeIn3 fadeInBottom">
                    <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                      <div className="bg-gradient-primary shadow-primary border-radius-lg py-3 pe-1">
                        <h4 className="text-white font-weight-bolder text-center mt-2 mb-0">Sign in</h4>
                      </div>
                    </div>
                    <div className="card-body">
                      <form role="form" className="text-start" onSubmit={this.handleSubmit}>
                        <div className="input-group input-group-outline my-3">
                          <input
                            className="form-control"
                            name="otp"
                            placeholder="Mobile"
                            value={this.state.otp}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="text-center">
                          <button type="submit" className="btn bg-gradient-primary w-100 my-4 mb-2">
                            Send OTP
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer className="footer position-absolute bottom-2 py-2 w-100">
              <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                  {/* <div className="col-12 col-md-6 my-auto">
                    <div className="copyright text-center text-sm text-white text-lg-start">
                      © {new Date().getFullYear()}, Developed by
                      <a
                        href="https://www.wemonde.com"
                        className="font-weight-bold text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Wemonde
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
            </footer>
          </div>
        </main>
      </div>
    );
  }
}

export default LoginOtp;
